/* eslint-disable @typescript-eslint/tslint/config */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable no-underscore-dangle */
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { JSONObject, JSONValue } from '../../class/workflow.type';
import { PageStates } from '../../dynamic-render/shared/workflow-navigation/workflow-navigation.type';
import { mergeJson, truncateObject } from '../../helper/merge-json/merge-json';
import { StatefulService } from '@app/service/stateful.service';

export interface NavigationPageState {
  /**
   * Indicate if page has been visited
   */
  isVisited?: boolean;

  /**
   * Indicate if page has been touched
   */
  isTouched?: boolean;

  /**
   * Indicate the page state in the navigation
   */
  state?: PageStates;
}

const DefaultPageState = { isTouched: false, isVisited: false, state: 'not-started' } as NavigationPageState;
// const PageStateStorageKey = 'ss:nav-page-state';
const PageStateStorageKey = 'extraData';

/**
 * Syncing in-memory and api/array other income desc
 */
@Injectable({ providedIn: 'root' })
export class WorkflowPageNavigationStateService {
  /** Navigation Retrieved */
  private readonly _navigationStateRetrieved$ = new BehaviorSubject<boolean>(false);

  /** An observable of page Submitted flag  */
  public get navigationStateRetrieved$(): Observable<boolean> {
    return this._navigationStateRetrieved$.asObservable();
  }

  /**
   * Page Visit and touched Status
   */
  private readonly navPagesState: { [id: string]: NavigationPageState } = {};

  /**
   * storagePrefix
   */
  private storagePrefix: string;

  constructor(private readonly statefulService: StatefulService) {}

  public setStoragePrefix(flowId: string): void {
    const isOLAFlow = flowId === 'ola' || (flowId && flowId.indexOf('ola-consumer') > -1);
    this.storagePrefix = isOLAFlow ? 'ola' : 'api';
    this.retrievePageState();
  }

  /**
   * Get immutable instance of the page state
   */
  public get(pageId: string): NavigationPageState {
    const navPageState = this.navPagesState[pageId] || DefaultPageState;
    return { ...navPageState };
  }

  /**
   * Update the state of specific page
   */
  public update(pageId: string, state: NavigationPageState): void {
    const navPageState = this.get(pageId);
    this.navPagesState[pageId] = { ...navPageState, ...state };
    this.savePageState();
  }

  private get getExtradataApiPath(): string {
    return `${this.storagePrefix}:${PageStateStorageKey}`;
  }

  private savePageState(): void {
    if (this._navigationStateRetrieved$.value) {
      // this.statefulService.wrap(this.getExtradataApiPath).value = JSON.stringify(this.navPagesState);
      this.statefulService.wrap(this.getExtradataApiPath).value = JSON.stringify(this.navPagesState);
    }
  }

  public retrievePageState(): void {
    // const state = this.statefulService.wrap(this.getExtradataApiPath);
    const state = this.statefulService.wrap(this.getExtradataApiPath);
    state.load(() => {
      truncateObject(<JSONObject>this.navPagesState);
      state.revert();
      const saved = JSON.parse(state.valueString || '{}');
      mergeJson(<JSONValue>this.navPagesState, saved);
      this._navigationStateRetrieved$.next(true);
      this.savePageState();
    });
  }

  public refreshPageState(): void {
    this._navigationStateRetrieved$.next(true);
  }
}
